module.exports = __webpack_public_path__ + "static/media/step4.ee6e4d89.png";